[
  {
    "id": "TB-M6-001",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Bijen zijn heel belangrijk voor de natuur. Ze vliegen van bloem naar bloem en nemen stuifmeel mee. Zo helpen ze planten om zich voort te planten. Zonder bijen zouden veel planten verdwijnen.\"\n\nWat is de hoofdgedachte van deze tekst?",
    "options": [
      "Bijen zijn belangrijk omdat ze planten helpen",
      "Bijen vliegen van bloem naar bloem",
      "Bijen houden van bloemen",
      "Planten verdwijnen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-HOOFDGEDACHTE",
    "explanation": "De tekst begint met 'Bijen zijn heel belangrijk voor de natuur' en legt daarna uit waarom. Dat is de hoofdgedachte.",
    "distractorExplanations": {
      "1": "Dit is een detail, niet de hoofdgedachte.",
      "2": "Dit staat niet letterlijk in de tekst.",
      "3": "Dit is een gevolg als er geen bijen zijn, niet de hoofdgedachte."
    }
  },
  {
    "id": "TB-M6-002",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"De Sahara is de grootste woestijn ter wereld. Overdag kan het er 50 graden worden. 's Nachts daalt de temperatuur soms tot onder het vriespunt.\"\n\nWat is bijzonder aan de temperatuur in de Sahara?",
    "options": [
      "Het verschil tussen dag en nacht is heel groot",
      "Het is er altijd warm",
      "Het vriest er elke nacht",
      "Het is er altijd 50 graden"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE",
    "explanation": "Overdag 50 graden, 's nachts onder het vriespunt. Het bijzondere is het enorme verschil tussen dag en nacht.",
    "distractorExplanations": {
      "1": "Het is niet altijd warm; 's nachts kan het vriezen.",
      "2": "Er staat 'soms', niet 'elke nacht'.",
      "3": "50 graden is het maximum overdag, niet altijd."
    }
  },
  {
    "id": "TB-M6-003",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Vroeger hadden kinderen geen televisie. Ze speelden buiten met vrienden. Ze maakten zelf speelgoed van hout en stof.\"\n\nWanneer speelt dit verhaal?",
    "options": [
      "Vroeger, in het verleden",
      "Nu, in het heden",
      "In de toekomst",
      "Dat kun je niet weten"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-LETTERLIJK",
    "explanation": "Het eerste woord is 'Vroeger'. Dat geeft aan dat het over het verleden gaat.",
    "distractorExplanations": {
      "1": "Het woord 'vroeger' geeft aan dat het niet nu is.",
      "2": "Er staat 'vroeger', niet 'straks' of 'in de toekomst'.",
      "3": "Je kunt het wel weten: het woord 'vroeger' vertelt het."
    }
  },
  {
    "id": "TB-M6-004",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Wat betekent het woord 'voortplanten' in de zin: 'Bijen helpen planten om zich voort te planten.'",
    "options": [
      "Nieuwe planten laten groeien",
      "Planten verplaatsen",
      "Planten water geven",
      "Planten beschermen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORDBETEKENIS",
    "explanation": "'Voortplanten' betekent dat er nieuwe planten (of dieren) ontstaan. Het woord 'voort' betekent 'verder' of 'nieuw'.",
    "distractorExplanations": {
      "1": "Voortplanten gaat niet over verplaatsen.",
      "2": "Water geven is iets anders.",
      "3": "Beschermen is iets anders dan voortplanten."
    }
  },
  {
    "id": "TB-M6-005",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"De vos is een slim dier. Hij jaagt 's nachts op muizen en konijnen. Overdag slaapt hij in zijn hol. De vos kan goed horen en ruiken.\"\n\nWelke zintuigen van de vos worden genoemd?",
    "options": [
      "Horen en ruiken",
      "Zien en horen",
      "Ruiken en zien",
      "Voelen en horen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-LETTERLIJK",
    "explanation": "De laatste zin zegt: 'De vos kan goed horen en ruiken.' Dat zijn de twee genoemde zintuigen.",
    "distractorExplanations": {
      "1": "Zien wordt niet genoemd.",
      "2": "Zien wordt niet genoemd.",
      "3": "Voelen wordt niet genoemd."
    }
  },
  {
    "id": "TB-M6-006",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Plastic is slecht voor het milieu. Het duurt honderden jaren voordat het afbreekt. Veel dieren worden ziek van plastic in de zee. Daarom is het belangrijk om minder plastic te gebruiken.\"\n\nWat wil de schrijver dat je doet?",
    "options": [
      "Minder plastic gebruiken",
      "Meer plastic kopen",
      "Plastic in de zee gooien",
      "Dieren helpen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-DOEL-SCHRIJVER",
    "explanation": "De laatste zin zegt: 'Daarom is het belangrijk om minder plastic te gebruiken.' De schrijver wil je overtuigen om minder plastic te gebruiken.",
    "distractorExplanations": {
      "1": "De tekst zegt juist dat plastic slecht is.",
      "2": "De tekst zegt dat plastic in de zee slecht is voor dieren.",
      "3": "Dieren helpen is goed, maar de tekst vraagt specifiek om minder plastic."
    }
  },
  {
    "id": "TB-M6-007",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"De otter was bijna uitgestorven in Nederland. Gelukkig zijn er maatregelen genomen. Nu leven er weer meer dan 400 otters in ons land.\"\n\nWat betekent 'uitgestorven'?",
    "options": [
      "Er zijn er geen meer over",
      "Er zijn er heel veel",
      "Ze zijn verhuisd",
      "Ze zijn ziek"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORDBETEKENIS",
    "explanation": "'Uitgestorven' betekent dat een diersoort helemaal verdwenen is. Er zijn er dan geen meer over.",
    "distractorExplanations": {
      "1": "Uitgestorven is het tegenovergestelde: er zijn er juist geen meer.",
      "2": "Verhuizen is iets anders dan uitsterven.",
      "3": "Ziek zijn is niet hetzelfde als uitgestorven."
    }
  },
  {
    "id": "TB-M6-008",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Hamsters slaan voedsel op in hun wangzakken. Ze kunnen hun wangen heel ver uitrekken. Thuis spugen ze het voedsel weer uit en bewaren het.\"\n\nIn welke volgorde doet de hamster dit?\n1. Voedsel bewaren\n2. Wangen vullen\n3. Voedsel uitspugen",
    "options": [
      "2 → 3 → 1",
      "1 → 2 → 3",
      "3 → 2 → 1",
      "2 → 1 → 3"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "volgorde",
    "familyId": "TB-VOLGORDE",
    "explanation": "Eerst vult de hamster zijn wangen (2), dan spuugt hij het uit (3), dan bewaart hij het (1).",
    "distractorExplanations": {
      "1": "Je kunt niet bewaren voordat je het hebt opgehaald.",
      "2": "Je kunt niet uitspugen voordat je wangen gevuld zijn.",
      "3": "Je bewaart pas als laatste stap."
    }
  },
  {
    "id": "TB-M6-009",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Het regent al de hele dag. Toch gaat Mila naar buiten. Ze trekt haar laarzen aan en pakt haar paraplu. 'Ik laat me niet tegenhouden door een beetje water!' zegt ze.\"\n\nWat voor iemand is Mila?",
    "options": [
      "Iemand die zich niet snel laat tegenhouden",
      "Iemand die bang is voor regen",
      "Iemand die niet van buiten houdt",
      "Iemand die altijd binnen blijft"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CONCLUSIE",
    "explanation": "Mila gaat ondanks de regen naar buiten en zegt: 'Ik laat me niet tegenhouden.' Ze is dus iemand die doorzet.",
    "distractorExplanations": {
      "1": "Ze gaat juist naar buiten in de regen, dus ze is niet bang.",
      "2": "Ze gaat juist naar buiten, dus ze houdt wel van buiten.",
      "3": "Ze gaat juist naar buiten."
    }
  },
  {
    "id": "TB-M6-010",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"De aarde draait om de zon. Eén rondje duurt precies 365 dagen. Dat noemen we een jaar. Elke 4 jaar is er een schrikkeljaar met 366 dagen.\"\n\nHoeveel dagen heeft een schrikkeljaar?",
    "options": [
      "366 dagen",
      "365 dagen",
      "364 dagen",
      "367 dagen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-LETTERLIJK",
    "explanation": "In de tekst staat: 'Elke 4 jaar is er een schrikkeljaar met 366 dagen.'",
    "distractorExplanations": {
      "1": "365 dagen is een normaal jaar, geen schrikkeljaar.",
      "2": "Dit staat niet in de tekst.",
      "3": "Dit staat niet in de tekst."
    }
  },
  {
    "id": "TB-M6-011",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Lees de tekst:\n\n\"Chocolade wordt gemaakt van cacaobonen. Die groeien in warme landen. De bonen worden eerst geroosterd en dan gemalen. Daarna wordt er suiker en melk aan toegevoegd.\"\n\nWat gebeurt er eerst met de cacaobonen?",
    "options": [
      "Ze worden geroosterd",
      "Ze worden gemalen",
      "Er wordt suiker aan toegevoegd",
      "Er wordt melk aan toegevoegd"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "volgorde",
    "familyId": "TB-VOLGORDE",
    "explanation": "De tekst zegt: 'De bonen worden eerst geroosterd en dan gemalen.' Het woord 'eerst' geeft de volgorde aan.",
    "distractorExplanations": {
      "1": "Malen komt na roosteren. Er staat 'eerst geroosterd en dan gemalen'.",
      "2": "Suiker komt pas daarna.",
      "3": "Melk komt pas daarna."
    }
  },
  {
    "id": "TB-M6-012",
    "module": "Taalbegrip",
    "difficulty": 103,
    "question": "Wat betekent het woord 'maatregelen' in de zin: 'Er zijn maatregelen genomen om de otter te beschermen.'",
    "options": [
      "Dingen die je doet om een probleem op te lossen",
      "Dingen die je meet met een liniaal",
      "Regels die je moet volgen op school",
      "Straffen voor als je iets fout doet"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORDBETEKENIS",
    "explanation": "'Maatregelen' zijn acties of stappen die je neemt om een probleem op te lossen of iets te verbeteren.",
    "distractorExplanations": {
      "1": "Het woord 'maat' in maatregelen heeft niets met meten te maken.",
      "2": "Maatregelen zijn breder dan alleen schoolregels.",
      "3": "Maatregelen zijn niet per se straffen, maar oplossingen."
    }
  }
]